/**
 * Room photos sourced from https://www.belvedereresort.com (official hotel site).
 * Local copies live under /public/campaigns/belvedere/rooms/.
 */
export const BELVEDERE_ROOM_IMAGE_ATTRIBUTION =
  "תמונות חדרים: Royal & Imperial Belvedere Resort (belvedereresort.com)";

export const BELVEDERE_DEFAULT_ROOM_IMAGE = "/campaigns/belvedere/gallery/belvedere-resort-04.jpg";

const ROOM_IMAGE_BY_ID = {
  "promo-economy": "/campaigns/belvedere/rooms/promo-economy.jpg",
  "superior-garden-single": "/campaigns/belvedere/rooms/superior-garden-single.jpg",
  "sea-view": "/campaigns/belvedere/rooms/sea-view.jpg",
  "superior-land": "/campaigns/belvedere/rooms/superior-land.jpg",
  "superior-sea": "/campaigns/belvedere/rooms/superior-sea.jpg",
  "superior-sea-high": "/campaigns/belvedere/rooms/superior-sea-high.jpg",
  "family-economy-4": "/campaigns/belvedere/rooms/family-economy-4.jpg",
  "family-economy-5": "/campaigns/belvedere/rooms/family-economy-5.jpg",
  "family-superior-land-4": "/campaigns/belvedere/rooms/family-superior-land-4.jpg",
  "family-superior-sea-4": "/campaigns/belvedere/rooms/family-superior-sea-4.jpg",
  "family-superior-land-5": "/campaigns/belvedere/rooms/family-superior-land-5.jpg",
  "suite-whirlpool-4": "/campaigns/belvedere/rooms/suite-whirlpool.jpg",
  "suite-whirlpool-5": "/campaigns/belvedere/rooms/suite-whirlpool.jpg",
};

const ROOM_IMAGE_ID_BY_CODE = {
  1: "promo-economy",
  2: "superior-garden-single",
  3: "sea-view",
  4: "superior-land",
  5: "superior-sea",
  6: "superior-sea-high",
  7: "family-economy-4",
  8: "family-economy-5",
  9: "family-superior-land-4",
  10: "family-superior-sea-4",
  12: "family-superior-land-5",
  13: "suite-whirlpool-4",
  14: "suite-whirlpool-5",
};

export function withBelvederePublicAsset(path) {
  if (!path || typeof path !== "string") return null;
  if (/^https?:\/\//i.test(path)) return path;
  const base = String(import.meta.env.BASE_URL || "/").replace(/\/?$/, "/");
  const normalized = path.startsWith("/") ? path.slice(1) : path;
  return `${base}${normalized}`;
}

export function getBelvedereRoomImageUrl(roomId) {
  if (!roomId) return null;
  const path = ROOM_IMAGE_BY_ID[roomId] ?? null;
  return path ? withBelvederePublicAsset(path) : null;
}

export function getBelvedereRoomImageByCode(roomCode) {
  const slug = ROOM_IMAGE_ID_BY_CODE[Number(roomCode)];
  return slug ? getBelvedereRoomImageUrl(slug) : null;
}

function roomCandidatesFromOffer(quote) {
  const rows = Array.isArray(quote?.roomBreakdown) ? quote.roomBreakdown : [];
  return [quote?.room, ...rows.map((row) => row?.room)].filter(Boolean);
}

export function resolveBelvedereRoomImageForOffer(quote) {
  for (const room of roomCandidatesFromOffer(quote)) {
    const byId = getBelvedereRoomImageUrl(room.id);
    if (byId) return byId;

    const slug = ROOM_IMAGE_ID_BY_CODE[Number(room.code)];
    const byCode = slug ? getBelvedereRoomImageUrl(slug) : null;
    if (byCode) return byCode;
  }

  return withBelvederePublicAsset(BELVEDERE_DEFAULT_ROOM_IMAGE);
}
